
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport05AllDialog extends Serenity.EntityDialog<IcReport05AllRow, any> {
        protected getFormKey() { return IcReport05AllForm.formKey; }
        protected getIdProperty() { return IcReport05AllRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport05AllRow.localTextPrefix; }
        protected getNameProperty() { return IcReport05AllRow.nameProperty; }
        protected getService() { return IcReport05AllService.baseUrl; }
        protected getDeletePermission() { return IcReport05AllRow.deletePermission; }
        protected getInsertPermission() { return IcReport05AllRow.insertPermission; }
        protected getUpdatePermission() { return IcReport05AllRow.updatePermission; }

        protected form = new IcReport05AllForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}